(function () {
  "use strict";
  var WEBWINKELKEUR_ID = "1218202";
  var PUBLIC_CODE = "97746ce774797ad1119008e00f7704e89029b0f39d80b365c6f585e3397e9517";
  var API_BASE_URL = "https://dashboard.webwinkelkeur.nl/api/1.0/product_reviews.json";
  var CACHE_KEY_PREFIX = "wwk_pr_v2_";
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours
  var MAX_FETCH_ATTEMPTS = 3;
  var RETRY_DELAY_MS = 1500;

  var reviewCache = {};
  var inflight = {};
  var doneDivs = new WeakSet(); // only divs with a DEFINITIVE outcome
  var productPageHasReviews = null;
  var domObserver = null;

  var STAR_SVG = '<svg class="valued-star-rating-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 22.5px; height: 20px; fill: #F8B22E;"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"></path></svg>';
  var HALF_STAR_SVG = '<svg class="valued-star-rating-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 22.5px; height: 20px;"><defs><linearGradient id="half-star-gradient"><stop offset="50%" stop-color="#F8B22E"/><stop offset="50%" stop-color="#E0E0E0"/></linearGradient></defs><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" fill="url(#half-star-gradient)"></path></svg>';
  var EMPTY_STAR_SVG = '<svg class="valued-star-rating-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 22.5px; height: 20px; fill: #E0E0E0;"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"></path></svg>';

  /* ---------- persistent cache (survives page loads / API outages) ---------- */

  function readStoredResult(productId) {
    try {
      var raw = window.localStorage.getItem(CACHE_KEY_PREFIX + productId);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || typeof entry.ts !== "number") return null;
      entry.fresh = (Date.now() - entry.ts) < CACHE_TTL_MS;
      return entry;
    } catch (e) {
      return null;
    }
  }

  function writeStoredResult(productId, average, count) {
    try {
      window.localStorage.setItem(
        CACHE_KEY_PREFIX + productId,
        JSON.stringify({ ts: Date.now(), average: average, count: count })
      );
    } catch (e) { /* storage full/blocked — non-fatal */ }
  }

  /* ---------- API ---------- */

  function fetchProductReviews(productId) {
    if (reviewCache[productId]) return Promise.resolve(reviewCache[productId]);
    if (inflight[productId]) return inflight[productId];

    var attempt = function (n) {
      var url = API_BASE_URL + "?id=" + WEBWINKELKEUR_ID +
        "&public_code=" + PUBLIC_CODE +
        "&product_id=" + encodeURIComponent(productId);
      return fetch(url).then(function (response) {
        if (!response.ok) throw new Error("WebwinkelKeur API status " + response.status);
        return response.json();
      }).catch(function (error) {
        if (n < MAX_FETCH_ATTEMPTS) {
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(attempt(n + 1)); }, RETRY_DELAY_MS * n);
          });
        }
        throw error;
      });
    };

    inflight[productId] = attempt(1).then(function (data) {
      reviewCache[productId] = data;
      delete inflight[productId];
      return data;
    }).catch(function (error) {
      delete inflight[productId];
      console.warn("WebwinkelKeur reviews unavailable for product", productId, error);
      return null; // null = UNKNOWN (do not treat as "no reviews")
    });
    return inflight[productId];
  }

  function calculateAverageRating(reviews) {
    if (!reviews || reviews.length === 0) return { average: 0, count: 0 };
    var sum = reviews.reduce(function (acc, r) { return acc + r.rating; }, 0);
    return { average: sum / reviews.length, count: reviews.length };
  }

  // innerHTML safety: output is built exclusively from script-owned SVG string
  // constants plus numeric values (Math-computed average, reviews.length count).
  // No API-supplied strings are ever interpolated, so XSS is not possible here.
  function generateStarHTML(rating, count) {
    var clampedRating = Math.max(0, Math.min(5, rating));
    var fullStars = Math.floor(clampedRating);
    var hasHalfStar = false;
    var fraction = clampedRating - fullStars;

    if (fraction >= 0.76) {
      fullStars += 1;
    } else if (fraction >= 0.3) {
      hasHalfStar = true;
    }

    var emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    var html = '<div class="valued-star-rating" style="display: flex; align-items: center; line-height: 1; margin-bottom: 5px;">';
    for (var i = 0; i < fullStars; i++) html += STAR_SVG;
    if (hasHalfStar) html += HALF_STAR_SVG;
    for (var j = 0; j < emptyStars; j++) html += EMPTY_STAR_SVG;
    html += '<span class="valued-rating-count" style="margin-left: 1rem; font-size: 16px; color: #333;">(' + count + ")</span></div>";
    return html;
  }

  /* ---------- collection cards ---------- */

  function renderBadge(reviewDiv, average, count) {
    reviewDiv.innerHTML = generateStarHTML(average, count);
    reviewDiv.style.removeProperty("display");
  }

  function hideBadge(reviewDiv) {
    reviewDiv.innerHTML = "";
    reviewDiv.style.display = "none";
  }

  function displayProductReview(reviewDiv) {
    if (doneDivs.has(reviewDiv)) return;
    var richSnippetDiv = reviewDiv.querySelector(".webwinkelkeur-rich-snippet");
    if (!richSnippetDiv) { doneDivs.add(reviewDiv); return; }
    var productId = richSnippetDiv.getAttribute("data-product-id");
    if (!productId) { doneDivs.add(reviewDiv); return; }

    // Instant paint from cache: never a blank badge for a reviewed product.
    var stored = readStoredResult(productId);
    if (stored && stored.count > 0) renderBadge(reviewDiv, stored.average, stored.count);

    // Always revalidate from the network so stale cached 5-star values can be corrected.
    // We still paint the cached value immediately, but the live result gets the final say.
    fetchProductReviews(productId).then(function (data) {
      if (data === null) {
        // API unreachable after retries: keep last-known cached badge (already
        // painted above) and leave div eligible for a future re-process pass.
        return;
      }
      doneDivs.add(reviewDiv); // definitive answer received
      var reviews = data.product_reviews || [];
      if (reviews.length === 0) {
        writeStoredResult(productId, 0, 0);
        hideBadge(reviewDiv);
        return;
      }
      var stats = calculateAverageRating(reviews);
      writeStoredResult(productId, stats.average, stats.count);
      renderBadge(reviewDiv, stats.average, stats.count);
    });
  }

  function processReviewDivs() {
    var reviewDivs = document.querySelectorAll(".webwinkelkeur-product-reviews");
    Array.prototype.filter.call(reviewDivs, function (div) {
      return !doneDivs.has(div);
    }).forEach(function (reviewDiv, index) {
      setTimeout(function () { displayProductReview(reviewDiv); }, index * 100);
    });
  }

  /* ---------- product page app block (unchanged behavior) ---------- */

  function findProductReviewNodes(root) {
    root = root || document;
    var appBlock = root.querySelector(".valued-product-reviews");
    var reviewRoot = (appBlock && appBlock.closest(".valued-dashboard-product-reviews-root")) ||
      root.querySelector(".valued-dashboard-product-reviews-root");
    var blockWrapper = (reviewRoot && reviewRoot.closest(".shopify-app-block, .shopify-block")) ||
      (appBlock && appBlock.closest(".shopify-app-block, .shopify-block")) || null;
    return { appBlock: appBlock, reviewRoot: reviewRoot, blockWrapper: blockWrapper };
  }

  function setNodeVisibility(node, isVisible) {
    if (!node) return;
    if (isVisible) {
      node.style.removeProperty("display");
      node.removeAttribute("hidden");
      node.classList.remove("wwk-reviews-hidden");
      node.classList.add("wwk-reviews-confirmed");
    } else {
      node.style.setProperty("display", "none", "important");
      node.setAttribute("hidden", "hidden");
      node.classList.add("wwk-reviews-hidden");
      node.classList.remove("wwk-reviews-confirmed");
    }
  }

  function applyProductPageReviewVisibility(hasReviews, root) {
    var nodes = findProductReviewNodes(root);
    if (!nodes.appBlock && !nodes.reviewRoot && !nodes.blockWrapper) return false;
    if (hasReviews) {
      setNodeVisibility(nodes.blockWrapper, true);
      setNodeVisibility(nodes.reviewRoot, true);
      setNodeVisibility(nodes.appBlock, true);
    } else {
      setNodeVisibility(nodes.blockWrapper || nodes.reviewRoot || nodes.appBlock, false);
    }
    return true;
  }

  function syncProductPageReviewVisibility(options) {
    if (productPageHasReviews === null) return;
    options = options || {};
    var maxAttempts = typeof options.maxAttempts === "number" ? options.maxAttempts : 20;
    var interval = typeof options.interval === "number" ? options.interval : 250;
    var attempt = 0;
    var run = function () {
      if (applyProductPageReviewVisibility(productPageHasReviews) || attempt >= maxAttempts) return;
      attempt += 1;
      window.setTimeout(run, interval);
    };
    run();
  }

  function injectAggregateRatingSchema(average, count) {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var schema = JSON.parse(scripts[i].textContent);
        if (schema["@type"] === "Product") {
          schema.aggregateRating = {
            "@type": "AggregateRating",
            ratingValue: String(Math.round(average * 10) / 10),
            reviewCount: String(count),
            bestRating: "5",
            worstRating: "1"
          };
          scripts[i].textContent = JSON.stringify(schema);
          return;
        }
      } catch (e) { /* skip malformed schema blocks */ }
    }
  }

  function validateProductPageAppBlock() {
    if (typeof window.dashProductId === "undefined") return;
    var productId = String(window.dashProductId);
    fetchProductReviews(productId).then(function (data) {
      if (data === null) {
        // API unreachable: fail OPEN on the product page (never hide real reviews).
        productPageHasReviews = true;
        syncProductPageReviewVisibility();
        return;
      }
      var reviews = data.product_reviews || [];
      productPageHasReviews = reviews.length > 0;
      if (productPageHasReviews) {
        var stats = calculateAverageRating(reviews);
        writeStoredResult(productId, stats.average, stats.count);
        injectAggregateRatingSchema(stats.average, stats.count);
      } else {
        writeStoredResult(productId, 0, 0);
      }
      syncProductPageReviewVisibility();
    });
  }

  function normalizeProductPageAverageRating() {
    if (typeof window.dashRatingValue === "undefined" || typeof window.dashRatingCount === "undefined") return false;

    var container = document.querySelector(".valued-average-ratings");
    if (!container) return false;

    var rating = Number(window.dashRatingValue);
    var count = Number(window.dashRatingCount);
    if (!isFinite(rating) || !isFinite(count)) return false;

    var clampedRating = Math.max(0, Math.min(5, rating));
    var fullStars = Math.floor(clampedRating);
    var hasHalfStar = false;
    var fraction = clampedRating - fullStars;

    if (fraction >= 0.76) {
      fullStars += 1;
    } else if (fraction >= 0.3) {
      hasHalfStar = true;
    }

    var normalizedRating = fullStars + (hasHalfStar ? 0.5 : 0);
    if (container.getAttribute("data-wwk-normalized-rating") === String(normalizedRating)) return true;

    container.innerHTML = generateStarHTML(normalizedRating, count);
    container.setAttribute("data-wwk-normalized-rating", String(normalizedRating));
    return true;
  }

  /* ---------- DOM observer — runs on EVERY page (fixes AJAX collection re-renders) ---------- */

  function nodeContainsReviewElements(node) {
    if (!node || node.nodeType !== 1) return false;
    var selector = ".webwinkelkeur-product-reviews, .valued-product-reviews, .valued-dashboard-product-reviews-root, .valued-average-ratings, .shopify-app-block, .shopify-block";
    return (node.matches && node.matches(selector)) ||
      (node.querySelector && !!node.querySelector(".webwinkelkeur-product-reviews, .valued-product-reviews, .valued-dashboard-product-reviews-root, .valued-average-ratings"));
  }

  function ensureDomObserver() {
    if (domObserver || !document.body) return;
    domObserver = new MutationObserver(function (mutations) {
      var shouldProcessCards = false;
      var shouldSyncProductPage = false;
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes || mutation.addedNodes.length === 0) return;
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!nodeContainsReviewElements(node)) return;
          if ((node.matches && node.matches(".webwinkelkeur-product-reviews")) ||
              (node.querySelector && node.querySelector(".webwinkelkeur-product-reviews"))) {
            shouldProcessCards = true;
          }
          if ((node.matches && node.matches(".valued-product-reviews, .valued-dashboard-product-reviews-root, .shopify-app-block, .shopify-block")) ||
              (node.querySelector && node.querySelector(".valued-product-reviews, .valued-dashboard-product-reviews-root"))) {
            shouldSyncProductPage = true;
          }
        });
      });
      if (shouldProcessCards) processReviewDivs();
      if (shouldSyncProductPage) syncProductPageReviewVisibility({ maxAttempts: 8, interval: 200 });
      normalizeProductPageAverageRating();
    });
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- init ---------- */

  function initializeReviews() {
    processReviewDivs();
    validateProductPageAppBlock();
    normalizeProductPageAverageRating();
    ensureDomObserver();
  }

  ["shopify:section:load", "shopify:section:reorder", "shopify:section:select", "shopify:block:select", "pageshow"].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      processReviewDivs();
      syncProductPageReviewVisibility({ maxAttempts: 12, interval: 200 });
    });
  });

  // Safety net: sweep for unprocessed badges (late AJAX renders, missed mutations).
  var sweeps = 0;
  var sweepTimer = window.setInterval(function () {
    sweeps += 1;
    processReviewDivs();
    normalizeProductPageAverageRating();
    if (sweeps >= 10) window.clearInterval(sweepTimer);
  }, 3000);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeReviews, { once: true });
  } else {
    initializeReviews();
  }
})();
